import { connect } from 'react-redux';
import { compose, hoistStatics, withState, lifecycle, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Navigation from './Navigation';
import fsh from '../../helpers/fromSubscriber.helper';
import mh from '../../helpers/messenger.helper';

const mapStateToProps = state => ({
  user: state.user.user,
  modulesTypes: state.modules.modulesTypes,
  backgroundColor: state.settings.backgroundPage,
  pages: state.modules.pages,
  pagesSettings: state.modules.pagesSettings,
  modules: state.modules.modulesSettings,
  customLinks: state.modules.customLinks,
  youtube: state.modules.youtube,
  vimeo: state.modules.vimeo,
  colorSchema: state.settings.subscriber.color,
  messenger: state.messenger,
});

const enhance = compose(
  connect(mapStateToProps, null),
  translate('portal'),
  withState('links', 'setLinks', []),
  withProps(props => ({
    countUnreadMessage: mh.getUnreadCountMessages(props.messenger),
  })),
  lifecycle({
    async componentDidMount() {
      this.props.setLinks(fsh.createNavLinks(this.props));
    },
  }),
);

export default withRouter(hoistStatics(enhance)(Navigation));



// WEBPACK FOOTER //
// ./src/components/navigation/index.js